import { format } from 'date-fns'
import clsx from 'clsx'
import BigNumber from 'bignumber.js'
import IconToken from '@/components/icons/IconToken'
import numberFormat from '@/utils/numberFormat'

export default function FundingFeeHistoryRow({ history }) {
  const {
    symbol,
    status,
    payment_type,
    funding_fee,
    funding_rate,
    created_time
  } = history
  const [type, baseCurrency] = symbol.split('_')
  const fundingRate = BigNumber(funding_rate).times(100).toFixed()
  const annualRate = BigNumber(fundingRate).times(3).times(365).toFixed()
  const fundingFee = BigNumber(funding_fee).negated()
  return (
    <tr className="table-list-row">
      <td className="table-list-cell align-left">
        <div className="token-label">
          <IconToken symbol={baseCurrency} />
          {baseCurrency}-{type}
        </div>
      </td>
      <td className="table-list-cell align-left">
        {numberFormat(fundingRate, 6)}%<span className="slash-symbol">/</span>
        {numberFormat(annualRate, 2)}%
      </td>
      <td className="table-list-cell align-left">{status}</td>
      <td className="table-list-cell align-left">{payment_type}</td>
      <td className="table-list-cell align-left">
        <span
          className={clsx({
            'color-positive': fundingFee.gt(0),
            'color-negative': fundingFee.lt(0)
          })}
        >
          {numberFormat(fundingFee.toNumber(), {
            formatKey: 'max8',
            signDisplay: true
          })}
        </span>
        <span className="token-symbol">USDC</span>
      </td>
      <td className="table-list-cell align-right">
        {format(created_time, 'yyyy-MM-dd HH:mm:ss')}
      </td>
    </tr>
  )
}
